import { Link } from "react-router-dom";
import Loader2 from "../../Components/Loader2";
import { useGetBrandsQuery } from "../../RTK/Slices/Slices/apiSliceMeat";

function Brands() {
  const { data, isError, isLoading } = useGetBrandsQuery();

  const brands = data?.data || [];

  if (isLoading) return <Loader2 />;
  if (isError)
    return (
      <div className="text-center text-red-500">فشل في تحميل البرندات</div>
    );

  return (
    <div className="container py-28 bg-gray-50">
      <h2 className="text-2xl font-bold text-red-600 mb-8 text-center">
        جميع البرندات
      </h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
        {brands.map((item) => (
          <Link
            to={`/ProductsBrand/${item?.brand_id}`}
            key={item.brand_id}
            className="bg-white rounded-xl hover:text-mainColor shadow-md p-4 flex flex-col items-center justify-center hover:shadow-lg hover:-translate-y-1 transition-all duration-300 cursor-pointer"
          >
            {/* صورة البراند (دائرية) */}
            <div
              style={{
                width: "100%",
                height: 90,
                borderRadius: 10,
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#fafafa",
                marginBottom: 10,
                border: "1px solid #eee",
              }}
            >
              {item?.image_url ? (
                <img
                  src={item.image_url}
                  alt={item?.brand_name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              ) : (
                <span className="text-xs text-gray-400 text-center px-1">
                  {item?.brand_name}
                </span>
              )}
            </div>

            {/* اسم البراند */}
            <span className="text-lg font-semibold text-center">
              {item.brand_name}
            </span>

            {/* خط أحمر تحته عند الهوفر */}
            <div className="mt-3 w-0 h-[3px] bg-red-500 transition-all duration-300 group-hover:w-full"></div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Brands;
